import { FC, useEffect, useState } from 'react';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { showAlert, useStores } from '~/utils';
import Customers from './Customers';

export const CustomersContainer: FC = () => {
  const navigate = useNavigate();

  const {
    customers: { customersList, getCustomers, setCurrentCustomer },
  } = useStores();

  const [isCustomersLoading, setIsCustomersLoading] = useState(true);

  const onGetCustomers = async (values: GetCustomersProps) => {
    setIsCustomersLoading(true);
    try {
      await getCustomers(values);
    } catch ({ message }) {
      showAlert({ message });
    } finally {
      setIsCustomersLoading(false);
    }
  };

  const handleCustomerDetails = async (values: Customer) => {
    setCurrentCustomer(values);
    navigate(Routes.CUSTOMER_ACCOUNTS);
  };

  useEffect(() => {
    onGetCustomers({});
  }, []);

  return (
    <Customers
      isCustomersLoading={isCustomersLoading}
      customersList={customersList}
      onPressCustomer={handleCustomerDetails}
      onChangePage={(page) => onGetCustomers({ page })}
    />
  );
};

export default observer(CustomersContainer);
